export enum AuthProviders {
  Password = 1,
  Google = 2,
  Microsoft = 3,
  LegacySystem = 4,
}
